<div id="loading" *ngIf="isLoading">
  {{
    orderChanged
      ? "Saving ordering of " + events.length + " passes..."
      : "Refreshing " + events.length + " passes..."
  }}
</div>
<!--  -->
<div class="save-button" *ngIf="!isLoading" (click)="save()">
  SAVE
</div>
<div
  class="fluid-container"
  cdkDropList
  cdkDropListOrientation="vertical"
  (cdkDropListDropped)="drop($event)"
>
  <div class="row header-row">
    <div class="col-1"></div>
    <div class="col-6 table_heading1">Name</div>
    <div class="col-2 table_heading1">Price</div>
    <div class="col-1 table_heading1">Max Avail</div>
    <div class="col-1 table_heading1">Sold</div>
    <div class="col-1 table_heading1">Visible</div>
  </div>
  <div
    class="row pass-row"
    *ngFor="let pass of passes; let i = index"
    style="cursor: default"
    cdkDrag
  >
    <div class="col-1" cdkDragHandle style="cursor: grab;">
      <mat-icon>sort</mat-icon>
    </div>
    <div
      class="col-6 body1"
      [ngClass]="{
        active: pass.isVis,
        lineskip: pass.product.isLineskip,
        cover: pass.product.isCover,
        drink: pass.product.isDrink,
        other: pass.product.isOther,
        bundle: pass.product.isBundle
      }"
    >
      {{ pass.name }}
    </div>
    <div
      class="col-2 body1"
      [ngClass]="{
        active: pass.isVis,
        lineskip: pass.product.isLineskip,
        cover: pass.product.isCover,
        drink: pass.product.isDrink,
        other: pass.product.isOther,
        bundle: pass.product.isBundle
      }"
    >
      {{ pass.price | currency }}
    </div>
    <div
      class="col-1 body1"
      [ngClass]="{
        active: pass.isVis,
        lineskip: pass.product.isLineskip,
        cover: pass.product.isCover,
        drink: pass.product.isDrink,
        other: pass.product.isOther,
        bundle: pass.product.isBundle
      }"
    >
      {{ pass.max }}
    </div>
    <div
      class="col-1 body1"
      [ngClass]="{
        active: pass.isVis,
        lineskip: pass.product.isLineskip,
        cover: pass.product.isCover,
        drink: pass.product.isDrink,
        other: pass.product.isOther,
        bundle: pass.product.isBundle
      }"
    >
      {{ pass.sold }}
    </div>
    <div
      class="col-1 body1"
      [ngClass]="{
        active: pass.isVis,
        lineskip: pass.product.isLineskip,
        cover: pass.product.isCover,
        drink: pass.product.isDrink,
        other: pass.product.isOther,
        bundle: pass.product.isBundle
      }"
    >
      <mat-icon *ngIf="pass.isVis">visibility</mat-icon>
      <mat-icon *ngIf="!pass.isVis">visibility_off</mat-icon>
    </div>
  </div>
</div>
